import ApiService from '@services/api.service'

export default {
    resource: '',

    list(params = null) {
        return ApiService.get(`/${this.resource}`, params)
    },

    show(model, params = null) {
        return ApiService.get(`/${this.resource}/` + model.id, params)
    },

    store(model) {
        return ApiService.post(`/${this.resource}`, model)
    },

    update(model) {
        return ApiService.put(`/${this.resource}/` + model.id, model)
    },

    delete(model) {
        return ApiService.delete(`/${this.resource}/` + model.id)
    },

    get(modelId, params = null) {
        return ApiService.get(`/${this.resource}/` + modelId, params)
    },
}
